import { render } from "./carruselultimo.vue?vue&type=template&id=63af7e79&scoped=true"
import script from "./carruselultimo.vue?vue&type=script&lang=js"
export * from "./carruselultimo.vue?vue&type=script&lang=js"

import "./carruselultimo.vue?vue&type=style&index=0&id=63af7e79&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63af7e79"]])

export default __exports__